// extracted by mini-css-extract-plugin
module.exports = {"keywords":"styles_keywords__2P0Xp","reverse":"styles_reverse__3hyr3","content":"styles_content__3BpVB","img":"styles_img__2qH4H"};